import { render, staticRenderFns } from "./ShelfPlanogram.vue?vue&type=template&id=53117bfe&scoped=true"
import script from "./ShelfPlanogram.vue?vue&type=script&lang=js"
export * from "./ShelfPlanogram.vue?vue&type=script&lang=js"
import style0 from "./ShelfPlanogram.vue?vue&type=style&index=0&id=53117bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53117bfe",
  null
  
)

export default component.exports